import { gql } from '@apollo/client';

export const separationGroupCompatibilityFragments = {
  separationGroupCompatibilityItem: gql`
    fragment SeparationGroupCompatibilityItem on SeparationGroupCompatibility {
      id
      description
      engineeringStatus
      updatedBy
      updatedTime
      updatedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      preparedTime
      preparedBy
      preparedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      checkedTime
      checkedBy
      checkedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      approvedTime
      approvedBy
      approvedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      separationGroupCable {
        name
      }
      separationGroupRaceway {
        name
      }
    }
  `,
};

export const GET_SEPARATION_GROUP_COMPATIBILITY_BY_ID = gql`
  ${separationGroupCompatibilityFragments.separationGroupCompatibilityItem}
  query SeparationGroupCompatibilityById($id: ID!) {
    separationGroupCompatibilityById(id: $id) {
      ...SeparationGroupCompatibilityItem
    }
  }
`;
export const SEARCH_SEPARATION_GROUP_COMPATIBILITIES = gql`
  ${separationGroupCompatibilityFragments.separationGroupCompatibilityItem}
  query SearchSeparationGroupCompatibilities($searchInput: SearchInput) {
    searchSeparationGroupCompatibilities(searchInput: $searchInput) {
      items {
        ...SeparationGroupCompatibilityItem
      }
    }
  }
`;

export const SAVE_SEPARATION_GROUP_COMPATIBILITIES = gql`
  ${separationGroupCompatibilityFragments.separationGroupCompatibilityItem}
  mutation SaveSeparationGroupCompatibility($separationGroupCompInput: [SeparationGroupCompInput!]!) {
    saveSeparationGroupCompatibility(separationGroupCompInput: $separationGroupCompInput) {
      separationGroupCompatibilities {
        ...SeparationGroupCompatibilityItem
      }
      errors
      infos
    }
  }
`;

export const ISSUE_SEPARATION_GROUP_COMPATIBILITIES = gql`
  ${separationGroupCompatibilityFragments.separationGroupCompatibilityItem}
  mutation IssueSeparationGroupCompatibilities(
    $issueSeparationGroupCompatibilityInput: IssueSeparationGroupCompatibilityInput!
  ) {
    issueSeparationGroupCompatibilities(
      issueSeparationGroupCompatibilityInput: $issueSeparationGroupCompatibilityInput
    ) {
      separationGroupCompatibilities {
        ...SeparationGroupCompatibilityItem
      }
      errors {
        messageKeys
      }
    }
  }
`;
